import React from 'react'

const ArticleV2PaddedSectionWrap = ({children}) => {
    return (
        <div>
            {children}

            <style jsx>{`
                div {
                    width: 600px;
                    margin: 0 auto;
                    // padding: 20px;
                }


                @media (max-width: 769px), (pointer: coarse) {
                    div {
                        width: 100%;
                        padding: 0 20px;
                        // padding: 20px;
                    }
                }
            `}</style>
        </div>
    )
}

export default ArticleV2PaddedSectionWrap